/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUserWeeklyScheduleExceptionDto } from '../../models/create-user-weekly-schedule-exception-dto';
import { ResponseUserWeeklyScheduleExceptionDto } from '../../models/response-user-weekly-schedule-exception-dto';

export interface UserWeeklyScheduleExceptionsControllerCreate$Params {
      body: CreateUserWeeklyScheduleExceptionDto
}

export function userWeeklyScheduleExceptionsControllerCreate(http: HttpClient, rootUrl: string, params: UserWeeklyScheduleExceptionsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>> {
  const rb = new RequestBuilder(rootUrl, userWeeklyScheduleExceptionsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>;
    })
  );
}

userWeeklyScheduleExceptionsControllerCreate.PATH = '/thalea-google-events/user-weekly-schedule-exceptions';
